import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 px-4 bg-[#FEF3E2]" data-id="element-55">
      <div className="max-w-3xl mx-auto" data-id="element-56">
        <div className="bg-gradient-to-br from-white to-[#FEF3E2] p-8 md:p-12 rounded-3xl border border-[#D4B896] text-center relative overflow-hidden" data-id="element-57">
          <div className="absolute top-0 right-0 -mt-10 -mr-10 text-[#EA580C]/5" data-id="element-58">
            <ShieldCheck className="w-64 h-64" data-id="element-59" />
          </div>

          <div className="relative z-10" data-id="element-60">
            <div className="w-20 h-20 mx-auto bg-[#EA580C]/10 rounded-full flex items-center justify-center mb-6" data-id="element-61">
              <ShieldCheck className="w-10 h-10 text-[#EA580C]" data-id="element-62" />
            </div>

            <h2 className="text-3xl font-bold text-[#3C1518] mb-4" data-id="element-63">
              Garantía de Satisfacción 100%
            </h2>

            <p className="text-xl text-[#5C2D0E] mb-6" data-id="element-64">
              Tenés <strong className="text-[#3C1518]" data-id="element-65">45 días</strong> para
              probar todas las recetas.
            </p>

            <p className="text-[#92400E] leading-relaxed max-w-xl mx-auto" data-id="element-66">
              Si por alguna razón sentís que este recetario no cumple con tus
              expectativas, o si tus tortas no mejoran siguiendo nuestros pasos,
              te devolvemos el 100% de tu dinero. Sin preguntas, sin
              complicaciones.
            </p>
          </div>
        </div>
      </div>
    </section>;
}